import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { BaseFilterProps } from "../types";

/**
 * Tags filter component.
 * Renders a list of tag options with checkboxes.
 */
export function TagsFilter({
  filter,
  config,
  onValueChange,
}: Omit<BaseFilterProps, 'isActive' | 'onToggle' | 'onRemove'>) {
  return (
    <>
      {config.options?.map((option) => (
        <label
          key={option.value}
          className="flex items-center gap-2 cursor-pointer hover:bg-muted p-2 rounded"
        >
          <Checkbox
            checked={filter.values.includes(option.value)}
            onCheckedChange={() => onValueChange(option.value)}
          />
          <span className="text-sm">{option.label}</span>
        </label>
      ))}
    </>
  );
}

export default TagsFilter;

